/**
 * @fileoverview PUT handler for the "/decisioning_studio_agents/:app_group_id/:dsa_id/audiences/distribution" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { decisioningStudioAgentsAppGroupIdDsaIdAudienceDistributionCacheKeys } from "./constants";
import type {
  PutDecisioningStudioAgentsAppGroupIdDsaIdAudienceDistributionProps,
  PutDecisioningStudioAgentsAppGroupIdDsaIdAudienceDistributionResult,
} from "./types";

export const putDecisioningStudioAgentsAppGroupIdDsaIdAudienceDistribution = reactQueryMutationAdapter(
  decisioningStudioAgentsAppGroupIdDsaIdAudienceDistributionCacheKeys,
  (
    props: PutDecisioningStudioAgentsAppGroupIdDsaIdAudienceDistributionProps
  ): Promise<PutDecisioningStudioAgentsAppGroupIdDsaIdAudienceDistributionResult> => {
    return fetch(
      `/decisioning_studio_agents/${props.appGroupId}/${props.dsaId}/audiences/distribution`,
      "PUT",
      {
        distribution: props.distribution,
      },
      undefined,
      { propagateFetchRequestError: false }
    );
  }
);
